import _app from "../../../server";
import { web_initialization } from "redux/actions/web"
import { auth__logout } from 'redux/actions/auth'
import logo from 'assets/img/brand/logo.svg';
import sygnet from 'assets/img/brand/sygnet.svg'

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, UncontrolledTooltip } from 'reactstrap';
import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


const propTypes = {
  dispatch: PropTypes.func,
  id: PropTypes.string,
};
const defaultProps = {};

const linkStyle = {
  textDecoration: 'none',
  color: '#000000'
}
const linkStyleW = {
  textDecoration: 'none',
  color: '#eee'
}
const badgeStyle = {
  position: 'absolute',
  right: 0,
  top: -5
}
const disabledStyle = {
  display: 'none',
}

const UserAvatar = ({ picture, token, backup }) => {
  if (picture.container && picture.filename) {
    let pic_link = `${_app.api}Storages/${picture.container}/download/${picture.filename}?access_token=${token}`;
    // console.log("avatar : ", pic_link);
    return (
      <img src={pic_link} className="img-avatar" alt="user email" />
    )
  }
  if (picture.link) {
    return (<img src={picture.link} className="img-avatar" alt="user email" />)
  }
  return (
    <img src={backup} className="img-avatar" alt="user email" />
  )
}

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      avatar: "assets/img/avatars/6.jpg",
      panicscount: 0,
    };
  }

  componentWillMount() {
    this.props.dispatch(web_initialization());
  }

  newEntriesPrompt = (value) => {
    if (value > 0) {
      return badgeStyle
    }
    else {
      return disabledStyle
    }
  }

  isOngoingPanic = () => {
    const { actives } = this.props._trackers
    let listItems = actives.list
    let trueCounter = 0;
    listItems.forEach((e) => {
      let strKey = e.toString()
      let activeStore = actives.byid[strKey]
      if (activeStore.isPanic === true) {
        trueCounter = trueCounter + 1
      }
    });
    return trueCounter
  }

  onlogout = () => {
    const { mqtt } = this.props
    if (mqtt.connected && !mqtt.disconnecting) {
      mqtt.end()
    }
    this.props.dispatch(auth__logout(this.props.token));
  }

  onProfile = () => {
    this.props.history.push('/profile');
  }

  render() {
    //console.log("------------------------------------\n", this.props._user)
    const reports_new = this.props._reports_new
    const summons_new = this.props._summons_new
    const { name, picture } = this.props._user
    const acc_role = this.props.auth.info.role
    const profile = this.props.auth.info.profile;

    let isPublic = false;
    if (profile.email === _app.dashboard) {
      isPublic = true;
    }
    let userRole = acc_role.charAt(0).toUpperCase() + acc_role.slice(1);
    let panicsCount = this.isOngoingPanic();
    //console.log("Panics Count : ", panicsCount);
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppNavbarBrand
          full={{ src: logo, width: 230, height: 35, alt: 'GuardExpert Logo' }}
          minimized={{ src: sygnet, width: 56, height: 35, alt: 'GuardExpert Logo' }}
        />
        <AppSidebarToggler className="d-md-down-none" display="lg" />

        <Nav className="d-md-down-none" navbar>
          <NavItem className="px-2">
            <Link to="/dashboard" style={linkStyle} className="hover-opa">Dashboard</Link>
          </NavItem>

          {(this.props.auth.info.role !== 'marshal' && !isPublic) &&
            <NavItem className="px-2">
              <Link to="/users" style={linkStyle} className="hover-opa">Users</Link>
            </NavItem>
          }
          {/* <NavItem className="px-2">
            <NavLink href="/users">Users</NavLink>
          </NavItem> */}

          {(this.props.auth.info.role !== 'marshal' && !isPublic) &&
            <NavItem className="px-2">
              <Link to="/devices" style={linkStyle} className="hover-opa">Devices</Link>
            </NavItem>
          }
          {(this.props.auth.info.role !== 'marshal' && !isPublic) &&
            <NavItem className="px-2">
              <Link to="/zones" style={linkStyle} className="hover-opa">Zones</Link>
            </NavItem>
          }
          {(this.props.auth.info.role !== 'marshal' && _app.summon && !isPublic) &&
            <NavItem className="px-2">
              <Link to="/offences" style={linkStyle} className="hover-opa">Traffic Offences</Link>
            </NavItem>
          }
          {/* <NavItem className="px-2">
            <NavLink href="/settings">Settings</NavLink>
          </NavItem> */}
        </Nav>

        <Nav className={(panicsCount > 0) ? 'ml-auto bg-primary p-2 blink-it radius-30' : 'ml-auto'} navbar>
          <span className={(panicsCount > 0) ? '' : 'd-none'}>
            <NavItem className="d-md-down-none hover-shadow animated fadeIn d-flex d-xl-none" id="new_panics_sm">
              <Link to="/panic/ongoing" style={linkStyle} className="m-auto"><i className="icon-flag"></i><Badge style={this.newEntriesPrompt(panicsCount)} pill color="danger">{panicsCount}</Badge></Link>
            </NavItem>
            <UncontrolledTooltip placement="bottom" target="new_panics_sm" className="animated fadeIn">Ongoing Panics</UncontrolledTooltip>

            <NavItem className="d-md-down-none hover-shadow animated fadeIn d-none d-xl-flex" id="new_panics_lg">
              <Link className="bg-light-gray radius-30 py-2 pl-3 pr-0" to="/panic/ongoing" style={linkStyle}>
                <span className="text-primary">{panicsCount} Marshals are in Danger!</span>
                {' '}<i className="icon-flag rounded-circle bg-white p-3 ml-1"></i><Badge style={this.newEntriesPrompt(panicsCount)} pill color="danger">{panicsCount}</Badge>
              </Link>
            </NavItem>
            <UncontrolledTooltip placement="bottom" target="new_panics_lg" className="animated fadeIn">Ongoing Panics</UncontrolledTooltip>
          </span>

          <NavItem className="d-md-down-none hover-shadow" id="new_reports">
            <Link to="/reports/active" style={(panicsCount > 0) ? linkStyleW : linkStyle}><i className="icon-note"></i><Badge style={this.newEntriesPrompt(reports_new)} pill color="dark">{reports_new}</Badge></Link>
          </NavItem>
          <UncontrolledTooltip placement="bottom" target="new_reports" className="animated fadeIn">New Reports</UncontrolledTooltip>

          {_app.summon &&
            <React.Fragment>
              <NavItem className="d-md-down-none hover-shadow" id="new_summons">
                <Link to="/traffic/issued" style={(panicsCount > 0) ? linkStyleW : linkStyle}><i className="icon-wallet"></i><Badge style={this.newEntriesPrompt(summons_new)} pill color="danger">{summons_new}</Badge></Link>
              </NavItem>
              <UncontrolledTooltip placement="bottom" target="new_summons" className="animated fadeIn">New Compounds</UncontrolledTooltip>
            </React.Fragment>
          }

          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <UserAvatar picture={picture} token={this.props.token} backup={this.state.avatar}></UserAvatar>
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              <DropdownItem header tag="div" className="text-left">
                <strong>{name}</strong>
                <div className="disabled">{'<'} {userRole} {'>'}</div>
              </DropdownItem>
              <a onClick={this.onProfile}><DropdownItem><i className="fa fa-user" /> Profile</DropdownItem></a>
              <a onClick={this.onlogout} ><DropdownItem><i className="fa fa-lock" /> Logout</DropdownItem></a>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    );
  }
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

const mapStateToProps = store => {
  return {
    token: store.auth.info.id,
    auth: store.auth,
    _reports_new: store.reports.reports_new,
    _summons_new: store.summons.summons_new,
    _user: store.endusers.user,
    _trackers: store.trackers
  }
}

UserAvatar.propTypes = {
  picture: PropTypes.object,
  token: PropTypes.string,
  backup: PropTypes.string
}

Header.propTypes = {
  dispatch: PropTypes.func,
  mqtt: PropTypes.object,
  token: PropTypes.string,
  auth: PropTypes.object,
  history: PropTypes.object,
  _reports_new: PropTypes.number,
  _summons_new: PropTypes.number,
  _user: PropTypes.object,
  _trackers: PropTypes.object
};

export default connect(
  mapStateToProps
)(Header)



// WEBPACK FOOTER //
// ./src/components/sections/Header/Header.js